import { createReducer } from 'Helpers/redux'
import {
  GET_CURATOR_NOTIFICATIONS,
  GET_ARTIST_NOTIFICATIONS,
  MARK_ARTIST_NOTIFICATIONS_AS_READ,
  MARK_CURATOR_NOTIFICATIONS_AS_READ,
} from '../actions/notificationsActions'

const initialState = {
  notifications: [],
}

const handlers = {
  [GET_CURATOR_NOTIFICATIONS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    notifications: payload.reverse(),
  }),
  [GET_ARTIST_NOTIFICATIONS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    notifications: payload.reverse(),
  }),
  [MARK_ARTIST_NOTIFICATIONS_AS_READ.SUCCESS]: prevState => ({
    ...prevState,
    notifications: prevState.notifications.map(el => ({
      ...el,
      isNew: false,
    })),
  }),
  [MARK_CURATOR_NOTIFICATIONS_AS_READ.SUCCESS]: prevState => ({
    ...prevState,
    notifications: prevState.notifications.map(el => ({
      ...el,
      is_new: false,
    })),
  }),
}

export default createReducer(initialState, handlers)
